module.exports = __webpack_public_path__ + "img/Support-skill-319.ac91c9a5.png";